import React, { memo } from 'react'
import styles from './PreviewSection.module.scss'
import PreviewSectionItem from '../../../../../common/components/preview-section-item/PreviewSectionItem'
import { SolarRecommendationForm } from '../../../../../model/solar-recommendation-form/solar-recommendation-form'

type Props = {
    form?: SolarRecommendationForm
    showDividerUnderTitle: boolean
}

const PreviewSection: React.FC<Props> = memo((props: Props) => {
    const { form, showDividerUnderTitle } = props

    return (
        <div className={styles.container}>
            <div className={styles.previewSection}>
                <div className={`${styles.previewSectionTitle} ${showDividerUnderTitle ? styles.dividerForTitle: ''}`}>
                    APPLIANCES
                </div>
                {
                    form?.appliances && <PreviewSectionItem items={
                        form.appliances.map(applianceItem => {
                            return {
                                data: [
                                    `Qty: ${applianceItem.quantity}`,
                                    `Daily usage: ${applianceItem.dailyUsage} hrs`,
                                ],
                                label: applianceItem.appliance.name
                            }
                        })
                    } />
                }
            </div>
            <div className={styles.previewSection}>
                <div className={`${styles.previewSectionTitle} ${showDividerUnderTitle ? styles.dividerForTitle: ''}`}>
                    PAYMENT PLAN
                </div>
                {
                    form?.paymentPlan && <PreviewSectionItem items={
                        [
                            {
                                data: form.paymentPlan?.alternatePowerExpense ? [form.paymentPlan?.alternatePowerExpense.toString()] : [],
                                label: 'Alternative Power Expense'
                            },
                            {
                                data: form.paymentPlan?.solarMonthlyRepayment ? [form.paymentPlan?.solarMonthlyRepayment.toString()] : [],
                                label: 'Solar Monthly Repayment'
                            },
                            {
                                data: form.paymentPlan?.paymentPlan ? [`${form.paymentPlan?.paymentPlan.toString()} Months`] : [],
                                label: 'Payment Plan'
                            },
                        ]
                    } />
                }
            </div>
            <div className={styles.previewSection}>
                <div className={`${styles.previewSectionTitle} ${showDividerUnderTitle ? styles.dividerForTitle: ''}`}>
                    INSTALLATION
                </div>
                {
                    form?.installation && <PreviewSectionItem items={
                        form.installation?.authorization ?
                        (
                            form.installation?.premiseType === 'Story Building' ?
                            [
                                {
                                    data: form.installation?.electricitySupply ? [form.installation?.electricitySupply.toString()] : [],
                                    label: 'Electricity Supply'
                                },
                                {
                                    data: form.installation?.peakUsagePeriod? [form.installation?.peakUsagePeriod.toString()] : [],
                                    label: "Peak usage period"
                                },
                                {
                                    data: form.installation?.conduciveness? ["Yes"] : ["No"],
                                    label: "Conduciveness"
                                },
                                {
                                    data: ['Yes'],
                                    label: 'Authorization'
                                },
                                {
                                    data: form.installation?.premiseType ? [form.installation?.premiseType.toString()] : [],
                                    label: 'Premise Type'
                                },
                                {
                                    data: form.installation?.floors ? [form.installation?.floors.toString()] : [],
                                    label: 'Floors'
                                },
                                {
                                    data: form.installation?.roofType ? [form.installation?.roofType.name.toString()] : [],
                                    label: 'Roof Type'
                                }
                            ]
                            :
                            [
                                {
                                    data: form.installation?.electricitySupply ? [form.installation?.electricitySupply.toString()] : [],
                                    label: 'Electricity Supply'
                                },
                                {
                                    data: form.installation?.peakUsagePeriod? [form.installation?.peakUsagePeriod.toString()] : [],
                                    label: "Peak usage period"
                                },
                                {
                                    data: form.installation?.conduciveness? ["Yes"] : ["No"],
                                    label: "Conduciveness"
                                },
                                {
                                    data: ['Yes'],
                                    label: 'Authorization'
                                },
                                {
                                    data: form.installation?.premiseType ? [form.installation?.premiseType.toString()] : [],
                                    label: 'Premise Type'
                                },
                                {
                                    data: form.installation?.roofType ? [form.installation?.roofType.name.toString()] : [],
                                    label: 'Roof Type'
                                }
                            ]
                        )
                        :
                        (
                            [
                                {
                                    data: form.installation?.electricitySupply ? [form.installation?.electricitySupply.toString()] : [],
                                    label: 'Electricity Supply'
                                },
                                {
                                    data: form.installation?.peakUsagePeriod? [form.installation?.peakUsagePeriod.toString()] : [],
                                    label: "Peak usage period"
                                },
                                {
                                    data: form.installation?.conduciveness? ["Yes"] : ["No"],
                                    label: "Conduciveness"
                                },
                                {
                                    data: ['No'],
                                    label: 'Authorization'
                                }
                            ]
                        )
                        
                    } />
                }
            </div>
        </div>
    )
})

export default PreviewSection